import Info from "./info";
export default Info;



//////////////////
// WEBPACK FOOTER
// ./app/modules/pois/patterns/info/index.ts
// module id = kx1O
// module chunks = 2